import { render, staticRenderFns } from "./index.vue?vue&type=template&id=f287d9aa&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "@/assets/main.css?vue&type=style&index=0&id=f287d9aa&scoped=true&lang=css&"
import style1 from "./index.vue?vue&type=style&index=1&id=f287d9aa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f287d9aa",
  null
  
)

export default component.exports